import { connectedStore } from '../../store';
import site from '../../site';
import blocks from '../../blocks';
import injectDependencies from '../helpers/inject-dependencies';

const withBlockTemplatesDependencies = (liveDocument, pageId = null) => {
  const store = connectedStore.get();
  const state = store.getState();
  const currentPage = pageId || site.selectors.getActivePageId(state);
  const usedBlocks = site.selectors.getUsedBlocks(state, currentPage);

  usedBlocks.forEach((blockId) => {
    const block = blocks.selectors.getBlock(state, blockId);

    if (block && block.templateId) {
      injectDependencies(liveDocument, block.templateId);
    }
  });
};

export default withBlockTemplatesDependencies;
